<template>
  <DWS msg="Welcome to Your Vue.js App"/>
</template>

<script>
import DWS from './components/DSW.vue'

export default {
  name: 'App',
  components: {
    DWS: DWS
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
